export default function DetailsItem(props) {
    const { heading, value, alignment = "center" } = props
    return <div style={{ marginBottom: "23px", width: "10em", wordWrap: "break-word", display: "flex", flexDirection: "column", alignItems: alignment, justifyContent: "center", wordBreak: "break-word", textAlign: "center" }}>
        <small >{heading}</small>
        <p className={'text-color'}>{value ? value : "-"}</p>
    </div>
}
